export enum ComponentTypes {
    // 占位符组件
    PLACEHOLDER = 'placeholder',
    // 占位符的icon
    PLACEHOLDERICON = 'placeholdericon',
    // 表格的单元格组件
    TABLECELL = 'tablecell',
    // 文字组件
    TEXTEDITOR = 'texteditor'
}
